import React from 'react';
import { Box, TextField, Typography } from '@mui/material';
import {RTL} from "../../../cache/CacheRtl";

/**
 * RepRangeSection - Form section for default rep range configuration
 * Allows setting default min/max reps that will be used when adding exercise to templates
 */
const RepRangeSection = ({
    formValues,
    setFieldValue,
    setFieldTouched,
    errors,
    touched
}) => {
    const handleMinRepsChange = (e) => {
        const value = e.target.value === '' ? null : parseInt(e.target.value, 10);
        setFieldValue('defaultMinReps', value);
    };

    const handleMaxRepsChange = (e) => {
        const value = e.target.value === '' ? null : parseInt(e.target.value, 10);
        setFieldValue('defaultMaxReps', value);
    };

    const handleBlur = (field) => {
        setFieldTouched(field);
    };

    // Validation: min should not be greater than max
    const hasRangeError = formValues.defaultMinReps != null &&
                          formValues.defaultMaxReps != null &&
                          formValues.defaultMinReps > formValues.defaultMaxReps;

    return (
        <Box>
            <Typography
                sx={{
                    fontWeight: 600,
                    fontSize: '15px',
                    color: '#1E293B',
                    mb: 2
                }}
            >
                טווח חזרות ברירת מחדל
            </Typography>
            <Typography
                sx={{
                    fontSize: '13px',
                    color: '#64748B',
                    mb: 2
                }}
            >
                הגדר טווח חזרות שיוגדר אוטומטית כאשר התרגיל יתווסף לתבנית
            </Typography>
            <RTL>
            <Box sx={{ display: 'flex', gap: 2 }}>
                <TextField
                    label="מינימום חזרות"
                    type="number"
                    value={formValues.defaultMinReps ?? ''}
                    onChange={handleMinRepsChange}
                    onBlur={() => handleBlur('defaultMinReps')}
                    error={hasRangeError}
                    helperText={hasRangeError ? 'מינימום לא יכול להיות גדול ממקסימום' : ''}
                    inputProps={{ min: 1, max: 100 }}
                    sx={{ flex: 1 }}
                    size="small"
                />
                <TextField
                    label="מקסימום חזרות"
                    type="number"
                    value={formValues.defaultMaxReps ?? ''}
                    onChange={handleMaxRepsChange}
                    onBlur={() => handleBlur('defaultMaxReps')}
                    error={hasRangeError}
                    inputProps={{ min: 1, max: 100 }}
                    sx={{ flex: 1 }}
                    size="small"
                />
            </Box>
            </RTL>
        </Box>
    );
};

export default RepRangeSection;
